module.exports = __webpack_public_path__ + "img/e2.604237d1.jpg";